export default __webpack_public_path__ + "static/icon-true-to-size-a790bef89979839349307bf7bd6e094d.webp";